// src/utils/env.js
export const VITE_ENV =
  (typeof import.meta !== "undefined" ? import.meta.env : undefined) || {};

export const IS_DEV =
  Boolean(VITE_ENV.DEV) || process.env.NODE_ENV === "development";

export const MODE = VITE_ENV.MODE || process.env.NODE_ENV || "development";
